import { TAppState } from '../../types/appState';
import { currentOpenChatSelector } from '../currentOpenChatSelector';

export const hintQuestionsSelector = (state: TAppState) => {
  const openChat = currentOpenChatSelector(state);

  return openChat?.hintQuestions.hints || [];
};
